import { Message } from '@mairistem/composants';

const ImportInformations = () => (
	<div className="information">
		<Message
			icon="info"
			header="Import depuis les logiciels métiers"
			content={
				<div className="importInformationsBody">
					<p>
						Choisissez l'application métier dont vous souhaitez exploiter les
						données pour alimenter vos prévisions budgétaires.
					</p>
					<p>
						Vous visualiserez alors la prévision annuelle, en distinguant les
						crédits déjà ouverts et les propositions à appliquer sur l'étape
						budgétaire en cours.
					</p>
				</div>
			}
		/>
	</div>
);

export default ImportInformations;
